

export const ROUTE_TO_PAY = '/pay/t/:token/o/:orderId/p/:paymentCode/amt/:amount/txAmt/:txAmount/svc/:serviceCharge/dvc/:deliveryCharge';
export const ROUTE_TO_PAGE_NOT_FOUND = '/pagenotfound'
export const ROUTE_TO_PAYMENT_COMPLETION = '/postpayment/t/:token/o/:orderId/p/:paymentId/i/:total/s/:sucess'